import React, { useEffect, useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import {
  Button,
  Tooltip,
  Overlay,
  Spinner,
  Table,
  Col,
  Row,
  Container,
  Stack,
} from "react-bootstrap";
import RegulatorService from "../../services/regulator.service";
import { FaLocationDot, FaCircleCheck, FaCircleXmark } from "react-icons/fa6";

function RegulatorDroneModal(props) {
  console.log(props);
  const type_user = sessionStorage.getItem("type_user");
  const handleconfirm = (type) => {
    const check = RegulatorService.UpdateDroneRegisStatus(
      props.content.drone_id,
      type,
      ""
    )
      .then((res) => {
        console.log(res);
        window.location.reload(false);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <Modal
      show={props.toggleModal}
      onHide={props.onHide}
      aria-labelledby="contained-modal-title-vcenter"
      backdrop="static"
      size="xl"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>ข้อมูลรายละเอียด</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Container>
          <Row>
            <Col className="d-flex justify-content-center align-items-center">
              <h5>ข้อมูลบุคคล</h5>
            </Col>
          </Row>
          <Row className="my-1" style={{ backgroundColor: "#DCDCDC" }}>
            <Col>ชื่อ - นามสกุล</Col>
            <Col>อีเมล</Col>
            <Col>เบอร์โทร</Col>
          </Row>
          <Row>
            <Col>
              {props.content.userdata.f_name} {props.content.userdata.l_name}
            </Col>
            <Col>{props.content.userdata.email}</Col>
            <Col>{props.content.userdata.phone}</Col>
          </Row>

          <Row className="my-3"></Row>
          <Row>
            <Col className="d-flex justify-content-center align-items-center">
              <h5>ข้อมูลโดรน</h5>
            </Col>
          </Row>

          <Row className="my-1" style={{ backgroundColor: "#DCDCDC" }}>
            <Col>รหัสอากาศยาน</Col>
            <Col>หมายเลขรหัสอากาศยาน</Col>
            <Col>ตราอากาศยาน</Col>
            <Col>รูปแบบอากาศยาน</Col>
          </Row>
          <Row>
            <Col>{props.content.drone_id}</Col>
            <Col>{props.content.drone_serial_number}</Col>
            <Col>{props.content.drone_brand}</Col>
            <Col>{props.content.drone_model}</Col>
          </Row>
          <Row className="my-1" style={{ backgroundColor: "#DCDCDC" }}>
            <Col xs={3}>รหัสอุปกรณ์ควบคุม</Col>
            <Col xs={3}>ตราอุปกรณ์ควบคุม</Col>
            <Col xs={3}>มี Built-in RemoteID</Col>
          </Row>
          <Row>
            <Col xs={3}>{props.content.controller_serial_number}</Col>
            <Col xs={3}>{props.content.controller_brand}</Col>
            {props.content.built_in_rid === 1 ? (
              <Col>มี</Col>
            ) : (
              <Col>ไม่มี</Col>
            )}
          </Row>
          <Row className="my-3"></Row>
          <Row>
            <Col className="d-flex justify-content-center align-items-center">
              <h5>ข้อมูลประกัน</h5>
            </Col>
          </Row>
          {props.content.weight < 2 ? (
            <div style={{color:"red",justifyContent:"center",alignItems:"center",display:"flex"}}>**เนื่องจากน้ำหนักไม่เกิน2กิโลกรัมจึงไม่จำเป็นต้องมีประกัน**</div>):(
            <>
            <Row className="my-1" style={{ backgroundColor: "#DCDCDC" }}>
            <Col>รหัสประกัน</Col>
            <Col>บริษัทประกัน</Col>
            <Col>ประเภทประกัน</Col>
            <Col>วงเงินประกัน</Col>
          </Row>
          <Row>
            <Col>{props.content.ins_number === null ? "":props.content.ins_number}</Col>
            <Col>{props.content.ins_company_name=== null ? "":props.content.ins_company_name}</Col>
            <Col>{props.content.ins_type=== null ? "":props.content.ins_type}</Col>
            <Col>{props.content.ins_limit=== null ? "":props.content.ins_limit}</Col>
          </Row>
          <Row className="my-1" style={{ backgroundColor: "#DCDCDC" }}>
            <Col xs={3}>วันที่เริ่มประกัน</Col>
            <Col xs={3}>วันที่สิ้นสุดประกัน</Col>
          </Row>
          <Row>
            <Col xs={3}>{props.content.ins_start=== null ? "":props.content.ins_start}</Col>
            <Col xs={3}>{props.content.ins_end=== null ? "":props.content.ins_end}</Col>
          </Row></>)}
          
        </Container>
      </Modal.Body>
      <Modal.Footer>
        {props.booleanInformationCheck[5] === "ตรวจสอบการชำระเงิน" ? (
          <h4 style={{ color: "red" }}>**กรุณายืนยันการชำระเงินก่อน</h4>
        ) : (
          ""
        )}

        <div style={{ display: "flex", gap: "20px" }}>
          <button
            className="custom-btn btnSave"
            onClick={props.viewInformation}
          >
            ดูรายละเอียดทั้งหมด
          </button>
          {props.booleanInformationCheck[3] === "อนุมัติเอกสาร" ||
          props.booleanInformationCheck[4] === "อนุมัติเอกสาร" ||
          props.booleanInformationCheck[5] === "อยู่ระหว่างพิจารณา" ? (
            <>
              {props.booleanInformationCheck[5] === "ชำระค่าพิจารณาคำขอ" ||
              props.booleanInformationCheck[5] === "ตรวจสอบการชำระเงิน" ? (
                <>
                  <button
                    style={{
                      display: "flex",
                      gap: "5px",
                      opacity: "0.7",
                      cursor: "context-menu",
                    }}
                    className="custom-btn btnDisable"
                    disabled
                    onClick={() => {
                      handleconfirm(7);
                    }}
                  >
                    &nbsp;
                    <h4 style={{ color: "black", margin: "auto" }}>
                      อนุมัติอากาศยาน
                    </h4>
                  </button>
                  <button
                    style={{
                      display: "flex",
                      gap: "5px",
                      opacity: "0.7",
                      cursor: "context-menu",
                    }}
                    className="custom-btn btnDisable"
                    disabled
                    onClick={() => {
                      handleconfirm(8);
                    }}
                  >
                    &nbsp;
                    <h4 style={{ color: "black", margin: "auto" }}>
                      ไม่อนุมัติอากาศยาน
                    </h4>
                  </button>
                </>
              ) : (
                <>
                  <button
                    style={{
                      display: "flex",
                      gap: "5px",
                      cursor: "context-menu",
                      opacity: "0.7",
                    }}
                    className={(sessionStorage.getItem("type_user") === "caat"
                      ? (props.booleanInformationCheck[3] ===
                        "อนุมัติการลงทะเบียน"
                        ? "custom-btn btnDisable"
                        : "custom-btn btnConfirm")
                      : (props.booleanInformationCheck[4] ===
                        "อนุมัติการลงทะเบียน"
                      ? "custom-btn btnDisable"
                      : "custom-btn btnConfirm"))}
                    
                    disabled={
                      (sessionStorage.getItem("type_user") === "caat"
                        ? (props.booleanInformationCheck[3] ===
                          "อนุมัติการลงทะเบียน"
                          ? true
                          : false)
                        : (props.booleanInformationCheck[4] ===
                          "อนุมัติการลงทะเบียน"
                        ? true
                        : false))
                    }
                    onClick={() => {
                      handleconfirm(7);
                    }}
                  >
                    <FaCircleCheck
                      style={{ marginTop: "5px", fontSize: "20px" }}
                    />
                    &nbsp;
                    <h4 style={{ color: "white", margin: "auto" }}>
                      อนุมัติอากาศยาน
                    </h4>
                  </button>
                  <button
                    style={{ display: "flex", gap: "5px" }}
                    className="custom-btn btnCancel"
                    onClick={() => {
                      handleconfirm(8);
                    }}
                  >
                    <FaCircleXmark
                      style={{ marginTop: "5px", fontSize: "20px" }}
                    />
                    &nbsp;
                    <h4 style={{ color: "white", margin: "auto" }}>
                      ไม่อนุมัติอากาศยาน
                    </h4>
                  </button>
                </>
              )}
            </>
          ) : (
            <>
              {props.booleanInformationCheck[3] ===
                "ไม่อนุมัติเอกสาร รอการแก้ไข" ||
              props.booleanInformationCheck[4] ===
                "ไม่อนุมัติเอกสาร รอการแก้ไข" ||
              props.booleanInformationCheck[3] === "ไม่อนุมัติการลงทะเบียน" ||
              props.booleanInformationCheck[4] === "ไม่อนุมัติการลงทะเบียน" ||
              (props.booleanInformationCheck[3] === "อนุมัติการลงทะเบียน" &&
                props.booleanInformationCheck[4] === "อนุมัติการลงทะเบียน") ||
              props.booleanInformationCheck[5] === "ตรวจสอบการชำระเงิน" ? (
                <>
                  <button
                    style={{
                      display: "flex",
                      gap: "5px",
                      opacity: "0.7",
                      cursor: "context-menu",
                    }}
                    className="custom-btn btnDisable"
                    disabled
                    onClick={() => {
                      handleconfirm(4);
                    }}
                  >
                    <FaCircleCheck
                      style={{ marginTop: "5px", fontSize: "20px" }}
                    />
                    &nbsp;
                    <h4 style={{ color: "black", margin: "auto" }}>
                      อนุมัติอากาศยาน
                    </h4>
                  </button>
                  <button
                    style={{
                      display: "flex",
                      gap: "5px",
                      opacity: "0.7",
                      cursor: "context-menu",
                    }}
                    className="custom-btn btnDisable"
                    disabled
                    onClick={() => {
                      props.onHide();
                      props.handleShowComment();
                    }}
                  >
                    <FaCircleXmark
                      style={{ marginTop: "5px", fontSize: "20px" }}
                    />
                    &nbsp;
                    <h4 style={{ color: "black", margin: "auto" }}>
                      ขอเอกสารเพิ่มเติม
                    </h4>
                  </button>
                </>
              ) : (
                <>
                  <button
                    style={{ display: "flex", gap: "5px" }}
                    className={(sessionStorage.getItem("type_user") === "caat"
                      ? (props.booleanInformationCheck[3] ===
                        "อนุมัติการลงทะเบียน"
                        ? "custom-btn btnDisable"
                        : "custom-btn btnConfirm")
                      : (props.booleanInformationCheck[4] ===
                        "อนุมัติการลงทะเบียน"
                      ? "custom-btn btnDisable"
                      : "custom-btn btnConfirm"))}
                    
                    disabled={
                      (sessionStorage.getItem("type_user") === "caat"
                        ? (props.booleanInformationCheck[3] ===
                          "อนุมัติการลงทะเบียน"
                          ? true
                          : false)
                        : (props.booleanInformationCheck[4] ===
                          "อนุมัติการลงทะเบียน"
                        ? true
                        : false))
                    }
                    onClick={() => {
                      handleconfirm(4);
                    }}
                  >
                    <FaCircleCheck
                      style={{ marginTop: "5px", fontSize: "20px" }}
                    />
                    &nbsp;
                    <h4 style={{ color: "white", margin: "auto" }}>
                      อนุมัติอากาศยาน
                    </h4>
                  </button>
                  <Button
                    style={{ display: "flex", gap: "5px" }}
                    className={(sessionStorage.getItem("type_user") === "caat"
                      ? (props.booleanInformationCheck[3] ===
                        "อนุมัติการลงทะเบียน"
                        ? "custom-btn btnDisable"
                        : "custom-btn btnCancel")
                      : (props.booleanInformationCheck[4] ===
                        "อนุมัติการลงทะเบียน"
                      ? "custom-btn btnDisable"
                      : "custom-btn btnCancel"))}
                    
                    disabled={
                      (sessionStorage.getItem("type_user") === "caat"
                        ? (props.booleanInformationCheck[3] ===
                          "อนุมัติการลงทะเบียน"
                          ? true
                          : false)
                        : (props.booleanInformationCheck[4] ===
                          "อนุมัติการลงทะเบียน"
                        ? true
                        : false))
                    }
                    onClick={() => {
                      props.onHide();
                      props.handleShowComment();
                    }}
                  >
                    <FaCircleXmark
                      style={{ marginTop: "5px", fontSize: "20px" }}
                    />
                    &nbsp;
                    <h4 style={{ color: "white", margin: "auto" }}>
                      ขอเอกสารเพิ่มเติม
                    </h4>
                  </Button>
                </>
              )}
            </>
          )}
        </div>
      </Modal.Footer>
    </Modal>
  );
}

export default RegulatorDroneModal;
